<template>
    <section class="video-banner--wrapper">
        <div class="pattern-bg"></div>
        <picture class="video-background hidden--md">
            <source media="(max-width: 480px)" srcset="/static/img/expat_page/mobile/expats_daniel_425.png 480w">
            <img src="/static/img/expat_page/daniel_expats_desktop.png">
        </picture>

        <div class="content-wrapper">
            <div class="content-container">
                <div class="heading-wrapper">
                    <div class="above-text">
                        <img src="/static/img/expat_page/quote_icon.svg"/>
                        <span class="work-with-us text-uppercase" style="margin-bottom: 2em">What is it like to live in Prague?</span>
                    </div>
                    <h1 class="text-uppercase heading">
                        PRAGUE IS A <span class="underline--gradient__green">BREATHTAKING</span>
                        CITY WITH A LOT TO OFFER AND ONE OF THE COOLEST <span class="underline--gradient__green">CITIES TO WORK IN EUROPE</span>.
                    </h1>
                    <span class="work-with-us text-uppercase quote">Daniel Sierra Hernandez / Engine Programmer <br/> Expat from Spain</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

  export default {
    name: "ImageBanner"
  };
</script>

<style scoped lang="scss">

    @import "../../assets/scss/globals";

    .video-background {
        img {
            width: 100%;
        }


    }

    .video-banner--wrapper {

        @media(max-width: $compact) {
            height: auto;
            margin-bottom: -4px;
        }
        position: relative;
        overflow: hidden;
        background-size: cover;
    }

    .pattern-bg {
        background: radial-gradient(rgba(0, 0, 0, 0.58) 20%, transparent 20%), radial-gradient(rgba(0, 0, 0, 0.58) 20%, transparent 20%), rgba(0, 0, 0, 0.21);
        background-position: 0 0, 4px 4px;
        -webkit-background-origin: padding-box;
        background-origin: padding-box;
        -webkit-background-clip: border-box;
        background-clip: border-box;
        -webkit-background-size: 8px 8px;
        background-size: 8px 8px;
        position: absolute;
        opacity: 0.8;
        width: 100%;
        z-index: 10;
        bottom: 0;
        top: 0;
    }


    .content-wrapper {
        height: 100%;
        position: absolute;
        top: 0;
        width: 100%;

        .content-container {
            max-width: 1200px;
            margin: auto;
            position: relative;
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: center;


            .heading-wrapper {
                z-index: 22;


                @media(max-width: $tablet) {
                    img {
                        width: 40px;
                        height: 27px;
                    }
                }
            }

            @media (max-width: $compact) {
                padding: 16px;
            }
        }
    }

    .heading {
        letter-spacing: 2px;
        line-height: 78px;
        font-size: 55px;
        color: white;
        z-index: 10;

        @media (max-width: $mq-md-max) {
            font-size: 35px;
            line-height: 50px;
        }

        @media (max-width: $mq-xs-max) {
            font-size: 32px;
            letter-spacing: 1.16px;
            line-height: 34px;
        }
        @media (max-width: 360px) {
            font-size: 18px;
            letter-spacing: 1.16px;
            line-height: 23px;


        }
    }


    .work-with-us {
        color: white;
        letter-spacing: 2px;
        margin-bottom: 2em;


        @media (max-width: 1280px) {
            font-size: 15px;
            letter-spacing: 0.74px;
        }

        @media (max-width: 768px) {
            font-size: 10px;
            letter-spacing: 0.74px;
        }
    }

    .underline--gradient__green {
        background-image: linear-gradient(to right, rgba(0, 186, 136, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        background-repeat: no-repeat;
        background-size: 100% 12px;


        @media(max-width: $tablet) {
            background-size: 100% 15px;
        }

        @media(max-width: $compact) {
            background-size: 100% 5px;
        }
    }

    /deep/ .above-text {
        margin-bottom: 2em;
    }

    .quote {
        justify-content: flex-end;
        display: flex;
        margin-top: 2em;

        @media (max-width: $compact) {
            justify-content: flex-start;
        }

    }


</style>


// WEBPACK FOOTER //
// src/components/expatsPageComponents/ImageBanner.vue